import React, { useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ErrorModal from '../ErrorModal';
import TranslationProvider, { getTranslation } from '../../providers/TranslationProvider';
import BrokenHeart from '../../svg/icons/ui-favorite.svg';
import useGdaNotificationData from '../NotifyGdaPage/useGdaNotificationData';
import { CONSTANTS } from '../Notify/notifyUtils';
import NotifyGdaModal from '../NotifyGdaPage/NotifyGdaModal';

const message = (
  <TranslationProvider translationKey="notify_table_no_longer_available">
    <div>Unfortunately, you didn&apos;t get this one, but you&apos;ll be notified if another table opens up.</div>
  </TranslationProvider>
);

const TableNotAvailable = ({
  Analytics, isGdaUser, matchMedia, locationCode, deviceId,
}) => {
  const [isOpen, setIsOpen] = useState(true);
  const [gdaVisibility, setGdaVisibility] = useState(false);
  const closeModal = () => setIsOpen(false);
  const { POST_NOTIFY } = CONSTANTS;
  const { data } = useGdaNotificationData({
    locationCode, deviceId, flowContext: POST_NOTIFY, fetchData: !isGdaUser,
  });

  const showGdaOrCloseModal = () => {
    if (data) {
      setGdaVisibility(true);
    } else {
      closeModal();
    }
  };

  const errorModalProps = {
    title: getTranslation({
      translationKey: 'notify_table_no_longer_available_title',
      fallback: 'Table no longer available',
    }),
    message,
    primaryCTAText: 'Ok',
    primaryCTAKey: 'ok',
    iconProps: {
      component: BrokenHeart,
      fill: '#ff462d',
      name: 'heart',
      height: '64px',
      width: '64px',
    },
    onErrorModalClose: closeModal,
    primaryCTAOnClick: showGdaOrCloseModal,
    modalStyles: {
      content: {
        inset: '30px',
        maxHeight: 'fit-content',
      },
    },
  };

  if (isOpen && gdaVisibility && data) {
    return <NotifyGdaModal isOpen={isOpen} onClose={closeModal} data={data} Analytics={Analytics} matchMedia={matchMedia} />;
  }
  return isOpen && <ErrorModal {...errorModalProps} />;
};

const tableNotAvailablePropTypes = {
  Analytics: PropTypes.shape({
    event: PropTypes.func,
  }).isRequired,
  isGdaUser: PropTypes.bool,
  matchMedia: PropTypes.shape({
    xs: PropTypes.bool,
    sm: PropTypes.bool,
    md: PropTypes.bool,
    lg: PropTypes.bool,
    ipadLandscape: PropTypes.bool,
    xl: PropTypes.bool,
  }).isRequired,
  locationCode: PropTypes.string,
  deviceId: PropTypes.string.isRequired,
};

TableNotAvailable.propTypes = tableNotAvailablePropTypes;

TableNotAvailable.defaultProps = {
  isGdaUser: false,
  locationCode: undefined,
};

const mapStateToProps = ({ matchMedia, resyLocations, resyConfig }) => ({
  matchMedia,
  locationCode: resyLocations.selected?.code,
  deviceId: resyConfig.deviceId,
});

TableNotAvailable.displayName = 'TableNotAvailable';
export { tableNotAvailablePropTypes, TableNotAvailable as ComponentUnderTest };
export default connect(mapStateToProps)(TableNotAvailable);
